import styles from "./Admin.module.scss";

interface Props {
  text: string;
}

const AdminHeader: React.FC<Props> = ({ text }) => {
  return (
    <div className={styles.adminHeader}>
      <div>{text}</div>
    </div>
  );
};

export default AdminHeader;
